<template>
  <div
    class="root group flex hover:bg-surf-neut-soft-hov items-center justify-between w-full rounded-4 pl-2 p-2 mr-2 py-2 cursor-pointer"
  >
    <div class="flex items-center">
      <div class="relative mr-4">
        <contact-avatar
          :contact="contact"
          :contact-type="contact.type"
        />
        <template v-if="contact.imLogin && imIsReady">
          <span
            v-if="contactStatusFromStore?.isOnline"
            class="absolute bottom-0 right-0.5 z-10 h-3.5 w-3.5 rounded-full ring-1 ring-bg-base-bg1"
            :class="statusClasses"
          />
          <span
            v-else
            class="absolute bottom-0 right-0.5 z-10 h-3.5 w-3.5 rounded-full border-2 border-bor-20 bg-bg-base-bg1 ring-1 ring-bg-base-bg1"
          />
        </template>
      </div>

      <div class="grid gap-y-2 truncate">
        <p
          data-test="name"
          class="text-1416 truncate"
        >
          {{ contact.name || t('common.noName') }}
        </p>

        <p
          v-if="contact.position || (showCallStatus && activeSession)"
          class="text-1316 truncate text-fg-base-fg22"
        >
          <template v-if="showCallStatus && activeSession">
            {{ t('calls.callEstablished') }}
          </template>
          <template v-else>
            {{ contact.position }}
          </template>
        </p>
      </div>
    </div>
    <div
      v-if="showCallStatus && activeSession"
      class="grid gap-y-2 pt-[6px]"
    >
      <wui-icon
        class="text-rackley-shades-600 w-5! h-5!"
        small
        name="phoneM"
      />
      <span class="text-1116 text-rackley-tints-600">
        {{ activeSession.timer.duration }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed, toRef } from 'vue'

import { useLiveCallSessions } from '@/entities/calls'
import { ContactAvatar } from '@/entities/contact-avatar'

import { useLocalization } from '@/shared/composables/localization'
import { useStatusClass } from '@/shared/composables/use-status-class'
import { useStoreContactStatus } from '@/shared/contact-status'
import { useIMStore } from '@/shared/store/im'
import { Contact } from '@/shared/types/api'

const props = defineProps<{
  contact: Contact,
  showCallStatus?: boolean
}>()

const { processSessions } = useLiveCallSessions()
const { t } = useLocalization()

const { imIsReady } = storeToRefs(useIMStore())

const contact = toRef(props, 'contact')

const { getStatusByPServed } = useStoreContactStatus()
const contactStatusFromStore = computed(() =>
  props.contact.imLogin ? getStatusByPServed(props.contact.imLogin) : undefined,
)
const contactStatus = computed(() => contactStatusFromStore.value?.status ?? 0)
const { statusClasses } = useStatusClass(contactStatus)

const activeSession = computed(() => processSessions.value.find(s => s.number === props.contact.internalNumber))
</script>

